import InsertDriveFile from 'material-ui/svg-icons/editor/insert-drive-file';
import React, {PropTypes} from 'react';

const getGradeText = grades => {
  const maxGradeNum = 9;

  if (grades.length >= maxGradeNum || grades.length === 0) return 'All Grades';
  if (grades.length === 1 && grades[0].short === 'K') return grades[0].long;

  return grades.map(g => g.short).join(', ');
};

const getCharacterDisplay = character => {
  if (!character) return null;
  return <div><span className="card-details bold-text">{character.name}</span> - {character.foundationShort}</div>;
};

export default function LibraryMaterialCard({material, onDocumentDownload}) {
  return (
    <div className="library-material-card" onClick={onDocumentDownload.bind(null, material.id)}>
      <div className="card-column card-column-left"><InsertDriveFile /></div>
      <div className="card-column card-column-right">
        <div className="card-title bold-text">{material.title}</div>
        <div className="card-details bold-text">{getGradeText(material.grades)}</div>
        { getCharacterDisplay(material.character) }
        <div className="card-footer bold-text">{material.materialType}</div>
      </div>
    </div>
  );
}

LibraryMaterialCard.propTypes = {
  material: PropTypes.object.isRequired,
  onDocumentDownload: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./app/features/library/components/LibraryMaterialCard.js